import {GrowthBook} from "@growthbook/growthbook";
import environment from "../constants/environments";

/** `react-scripts start` sets NODE_ENV=development for UAT too — key off the API host, not NODE_ENV alone. */
const growthBookDevMode =
  process.env.NODE_ENV === "development" &&
  /api-feature1\.mytatva\.in/i.test(process.env.REACT_APP_API_URL || "");

/** Non-prod and prod use different GrowthBook client keys; expose env for rules on the shared dev/UAT key. */
const growthBookAppEnv = (): "development" | "uat" | "production" => {
  const api = process.env.REACT_APP_API_URL || "";
  if (/^https:\/\/api\.mytatva\.in/i.test(api)) return "production";
  if (/uat/i.test(api)) return "uat";
  return "development";
};

export const growthbook = new GrowthBook({
  apiHost: environment.REACT_APP_GROWTHBOOK_API_HOST,
  clientKey: environment.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: growthBookDevMode,
  subscribeToChanges: true,
});

let cachedCoachId: string | null = null;

export const syncGrowthBookAttributes = (): boolean => {
  const healthCoachIdFromStorage = localStorage.getItem("health_coach_id");
  let userInfo: {health_coach_id?: string} = {};

  try {
    userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  } catch {
    userInfo = {};
  }

  const healthCoachId =
    healthCoachIdFromStorage || userInfo?.health_coach_id || "";

  growthbook.setAttributes({
    id: healthCoachId,
    healthCoachId,
    appEnv: growthBookAppEnv(),
  });

  const changed = healthCoachId !== cachedCoachId;
  cachedCoachId = healthCoachId;
  return changed;
};

/** Attributes must be set before the first remote feature fetch (coach targeting). */
export const initGrowthBook = () => {
  syncGrowthBookAttributes();
  return growthbook.loadFeatures({});
};
